import * as yup from "yup";

import { FormId } from "../../../../components/enums";
import {
  carMakeValidator,
  carModelValidator,
  cityValidator,
  countryValidator,
  emailValidator,
  insuranceCompanyValidator,
  nameSurnameValidator,
  ocNumberValidatorRequired,
  phoneValidator,
  postalCodeGenericValidator,
  postalCodePolandValidator,
  provinceValidator,
  registrationNumberValidatorRequired,
  streetHouseNumberValidator,
  streetValidator,
} from "../../../../utilities/validators";
import { trimmedString } from "../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.PERPETRATOR_OWNER]: yup.object({
    [ComponentId.PERPETRATOR_OWNER_NAME]: trimmedString.onlyIfFieldIsVisible(
      nameSurnameValidator
    ),
    [ComponentId.PERPETRATOR_OWNER_SURNAME]: trimmedString.onlyIfFieldIsVisible(
      nameSurnameValidator
    ),
    [ComponentId.PERPETRATOR_OWNER_PHONE]: phoneValidator("ownerphone"),
    [ComponentId.PERPETRATOR_OWNER_EMAIL]: trimmedString.onlyIfFieldIsVisible(
      emailValidator
    ),
    [ComponentId.PERPETRATOR_OWNER_STREET]: trimmedString.onlyIfFieldIsVisible(
      streetValidator
    ),
    [ComponentId.PERPETRATOR_OWNER_STREET_2]: trimmedString.onlyIfFieldIsVisible(
      streetHouseNumberValidator
    ),
    [ComponentId.PERPETRATOR_OWNER_ZIP_CODE_PL]: trimmedString.onlyIfFieldIsVisible(
      postalCodePolandValidator
    ),
    [ComponentId.PERPETRATOR_OWNER_ZIP_CODE_GENERIC]: trimmedString.onlyIfFieldIsVisible(
      postalCodeGenericValidator
    ),
    [ComponentId.PERPETRATOR_OWNER_CITY]: trimmedString.onlyIfFieldIsVisible(
      cityValidator
    ),
    [ComponentId.PERPETRATOR_OWNER_COUNTRY]: yup
      .object()
      .onlyIfFieldIsVisible(countryValidator),
    [ComponentId.PERPETRATOR_OWNER_PROVINCE]: trimmedString.onlyIfFieldIsVisibleProvince(
      provinceValidator
    ),
    [ComponentId.PERPETRATOR_OWNER_REGISTRATION_NUMBER]: trimmedString.onlyIfFieldIsVisible(
      registrationNumberValidatorRequired
    ),
    [ComponentId.PERPETRATOR_OWNER_MAKE]: trimmedString.onlyIfFieldIsVisible(
      carMakeValidator
    ),
    [ComponentId.PERPETRATOR_OWNER_MODEL]: trimmedString.onlyIfFieldIsVisible(
      carModelValidator
    ),
    [ComponentId.PERPETRATOR_OWNER_OC_NUMBER]: trimmedString.onlyIfFieldIsVisible(
      ocNumberValidatorRequired
    ),
    [ComponentId.PERPETRATOR_OWNER_INSURANCE_COMPANY]: trimmedString.onlyIfFieldIsVisible(
      insuranceCompanyValidator
    ),
  }),
};
